import { ResourceDto } from '@lmt/shared-types';
import { ButtonColor } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { UniLink } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/UniLink';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import { useUniSelector } from '@lmt/unicorn-shared/app/store/types';
import React, { FC } from 'react';
import styles from './ResourceInfo.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  resourceIcon: any;
  resources: ResourceDto[];
  onItemClick: (resourceId: number) => void;
}

export const ResourceInfo: FC<Props> = (props) => {
  const { resourceIcon, resources } = props;
  const claims = useClaims();
  const i18n = useTranslation();
  if (!resources.length) {
    return null;
  }
  return (
    <div className={styles.container}>
      {resourceIcon}
      <div className={styles.itemsList}>
        {resources.map((resource) => (
          <div className={styles['resource-info']}>
            <UniLink
              key={resource.id}
              color={ButtonColor.Primary}
              className={styles.resourceName}
              title={resource.name}
              onClick={() => props.onItemClick(resource.id)}
              disabled={!claims.permissions.manageAbsences}
            />
            {resource.isDeleted && (
              <span className={styles['deleted-resource-label']}>
                {i18n.t('event.visit.deleted_resource_label')}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
